import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MetaTags from "./index";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function tags(action) {
  const text = (() => {
    switch (action) {
      case "index":
        return "アカウント情報";
      case "edit":
        return "アカウント基本情報の変更";
      case "product":
        return "利用状況";
      case "unsubscribe-step1":
        return "解約申込";
      case "unsubscribe-step2":
        return "解約アンケート";
      case "unsubscribe-step3":
        return "解約完了";
      case "paymentmethod":
        return "支払い方法";
      case "addpayment":
        return "支払い方法の追加・変更";
      case "paymenthistory":
        return "支払い履歴";
      case "withdraw":
        return "利用登録解除確認";
      case "withdrawcomplete":
        return "利用登録解除完了";
      case "password":
        return "パスワード変更";
      case "mailOption":
        return "ご案内メール受信設定";
    }
  })();
  return {
    vod: {
      title: `${text} | SPOOX(スプークス)`,
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル",
      description: `${text}。SPOOX(スプークス)では、スポーツや映画やアニメなど、様々な動画を配信中です。`,
      og: {
        type: "article"
      }
    }
  };
}
export default function AccountMetaTags(_ref) {
  let {
    action
  } = _ref;
  const props = tags(action)["vod"];
  const noindex = useMemo(() => {
    if (action === "unsubscribe-step2" || action === "unsubscribe-step3" || action === "withdrawcomplete") {
      return "noindex";
    } else {
      return null;
    }
  }, [action]);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread(_objectSpread({}, props), {}, {
    robots: noindex
  }));
}